import { IntlShape } from 'react-intl';
import { asPercentFraction } from './marketsRange';

/**
 * A market delta reads as a signed percentage with one decimal: `+4.2%`. The
 * sign comes from `Intl`, so it stays right in every locale, and a flat row
 * reads `0%` rather than an empty cell.
 */
export function formatDelta(intl: IntlShape, delta: number): string {
  return intl.formatNumber(asPercentFraction(delta), {
    style: 'percent',
    signDisplay: 'exceptZero',
    maximumFractionDigits: 1,
  });
}
